var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('t-modal-file', {
    ref: "openModalUploadCSV"
  }, [_c('h3', {
    staticClass: "font-bold mb-0 px-2 text-base text-gray-700"
  }, [_vm._v(" Import CSV ")]), _c('div', {
    staticClass: "flex justify-start w-full px-0 pt-0 py-3"
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.handleFiles
    }
  }), _vm.file === null ? _c('div', {
    staticClass: "mr-2.5 w-full"
  }, [_vm.isErrorValidate ? _c('div', {
    staticClass: "bg-red-50 text-red-700 py-2.5 px-3 rounded-lg mb-3"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-exclamation"
  }), _c('label', {
    staticClass: "text-sm ml-2 font-semibold"
  }, [_vm._v(_vm._s(_vm.validateObject.nameError))]), _c('p', {
    staticClass: "mb-0 text-xs"
  }, [_vm._v(_vm._s(_vm.validateObject.description))])]) : _vm._e(), _c('div', {
    staticClass: "bg-gray-50 h-40 rounded-xl dropzone-style justify-center items-center flex border-t border-l border-b border-r border-dashed border-gray-300",
    on: {
      "dragover": function ($event) {
        $event.preventDefault();
      },
      "dragenter": function ($event) {
        $event.preventDefault();
      },
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.handleDrop.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "dropzone-content flex justify-center items-center flex-col"
  }, [_c('div', {
    staticClass: "icon mb-2"
  }, [_c('svg', {
    staticClass: "w-6 h-6 text-gray-400 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M12 5v9m-5 0H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2M8 9l4-5 4 5m1 8h.01"
    }
  })])]), _c('p', {
    staticClass: "text-sm text-gray-500 m-0"
  }, [_vm._v("Drag and drop here")]), _c('p', {
    staticClass: "text-xs text-blue-500 cursor-pointer my-1 m-0",
    class: {
      'opacity-50 bg-gray-500': _vm.disabled
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.triggerFile.apply(null, arguments);
      }
    }
  }, [_vm._v(" or choose from computer ")])])]), _c('p', {
    staticClass: "text-sm text-gray-500 mt-3 mb-0"
  }, [_vm._v(" Please ensure your file matches the template format "), _c('a', {
    staticClass: "not-italic cursor-pointer text-blue-500 hover:underline",
    attrs: {
      "href": "https://ebooks.gramedia.com/ebook-statics/bulk-uploader/Template+Smartpin.csv",
      "target": "_blank",
      "rel": "noopener noreferrer",
      "download": ""
    }
  }, [_vm._v(" Download template sample ")])])]) : _c('div', {
    staticClass: "ml-2 pt-0 w-full"
  }, [_vm.isLoadingProgress ? _c('ProgressSection', {
    attrs: {
      "progress": _vm.progress,
      "fileName": _vm.fileName,
      "disabled": !_vm.file
    },
    on: {
      "generate": _vm.importCSV
    }
  }) : _c('div', {
    staticClass: "flex justify-start items-center border rounded-lg w-full py-2 px-3"
  }, [_c('div', {
    staticClass: "flex-col w-full"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', [_c('p', {
    staticClass: "text-left mb-0 text-sm text-gray-700 font-semibold"
  }, [_vm._v(_vm._s(_vm.fileName))]), _c('p', {
    staticClass: "text-left text-xs text-gray-500 mb-0"
  }, [_vm._v(_vm._s(_vm.readableFileSize(_vm.fileSize)))])]), _c('div', [_c('Button', {
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "xs"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.triggerFile.apply(null, arguments);
      }
    }
  }, [_vm._v(" Change ")])], 1)])])])], 1)]), !_vm.isLoadingProgress ? _c('div', {
    staticClass: "flex justify-start items-start space-x-4"
  }, [_c('Button', {
    staticClass: "flex justify-items-start items-center text-white",
    class: _vm.file ? 'bg-blue-500' : 'bg-gray-300 text-white',
    attrs: {
      "variant": "default",
      "color": _vm.file ? 'primary' : 'alternative',
      "size": "xs"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.importCSV.apply(null, arguments);
      }
    }
  }, [_vm._v(" Import ")]), _c('Button', {
    staticClass: "flex justify-items-start items-center",
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "xs"
    },
    on: {
      "click": _vm.closeUploadModal
    }
  }, [_vm._v(" Cancel ")])], 1) : _vm._e()]), _c('t-modal-table-content', {
    ref: "openTableGenerateCSV"
  }, [_c('div', {
    staticClass: "csv-review-modal flex flex-col p-2 mx-auto"
  }, [_c('div', {
    staticClass: "flex justify-between items-center mb-0"
  }, [_c('h3', {
    staticClass: "font-bold mb-3 text-base text-gray-700"
  }, [_vm._v("Review Selected Content")])]), _c('div', {
    staticClass: "relative w-96 mb-4"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "hide-native-search p-2.5 pl-10 pr-10 w-full text-sm border rounded-lg focus:ring-blue-500 focus:border-blue-500",
    attrs: {
      "placeholder": "Search book name or ID...",
      "type": "text"
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value;
      }
    }
  }), _vm.searchQuery ? _c('i', {
    staticClass: "fa-solid fa-xmark text-gray-400 text-base absolute top-3 right-3 cursor-pointer hover:text-gray-600",
    on: {
      "click": _vm.clearSearch
    }
  }) : _vm._e()]), !_vm.baseData.is_valid ? _c('div', {
    staticClass: "bg-orange-50 p-2 rounded-lg mb-4 text-yellow-800"
  }, [_c('label', {
    staticClass: "text-base font-semibold mb-0 leading-10"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info mr-2"
  }), _vm._v(" Confirmation Content ")]), _c('p', {
    staticClass: "tex-sm mb-2"
  }, [_vm._v("Please review the content for the Onsite feature again. If there are any errors, you won't be able to save it. Make sure to correct them first.")])]) : _vm._e(), _c('div', {
    staticClass: "csv-review-table border rounded-lg"
  }, [_c('table', {
    staticClass: "min-w-full bg-white"
  }, [_c('thead', {
    staticClass: "sticky top-0 z-10 bg-gray-50 border-b"
  }, [_c('tr', [_c('th', {
    staticClass: "px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
  }, [_vm._v("Image")]), _c('th', {
    staticClass: "px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
  }, [_vm._v("Book name")]), _c('th', {
    staticClass: "px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
  }, [_vm._v("Type")]), _c('th', {
    staticClass: "px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
  }, [_vm._v("Reason")])])]), _c('tbody', {
    staticClass: "divide-y divide-gray-200"
  }, [_vm._l(_vm.filteredData, function (item, index) {
    return _c('tr', {
      key: index,
      staticClass: "hover:bg-gray-50"
    }, [_c('td', {
      staticClass: "px-6 py-1 whitespace-nowrap text-sm text-gray-500"
    }, [item.thumb_image_normal ? _c('img', {
      staticClass: "h-10 w-10 object-cover rounded-none",
      attrs: {
        "src": 'https://ebooks.gramedia.com/ebook-covers/' + _vm.removeBucket(item.thumb_image_normal)
      }
    }) : _c('img', {
      staticClass: "h-10 w-10 object-cover rounded-none",
      attrs: {
        "src": _vm.DefaultImage,
        "alt": "empty thumb"
      }
    })]), _c('td', {
      staticClass: "px-6 py-1 whitespace-nowrap text-sm text-gray-700"
    }, [_vm._v(" " + _vm._s(item.name || '-') + " "), _c('p', [_vm._v("ID: " + _vm._s(item.id))])]), _c('td', {
      staticClass: "px-6 py-1 whitespace-nowrap text-sm text-gray-500 capitalize"
    }, [_vm._v(_vm._s(item.type || '-'))]), _c('td', {
      staticClass: "px-6 py-1 whitespace-nowrap text-sm text-gray-500 capitalize"
    }, [_c('span', {
      staticClass: "py-1 font-normal rounded-lg text-xs px-1.5",
      class: item.is_valid ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'
    }, [_vm._v(" " + _vm._s(item.is_valid ? 'Passed' : 'Failed') + " ")])]), _c('td', {
      staticClass: "px-6 py-1 w-full align-middle whitespace-normal text-sm text-gray-500 capitalize max-w-xs"
    }, [_c('p', {
      staticClass: "text-sm break-words mb-0"
    }, [_vm._v(" " + _vm._s(item.message || '') + " ")])])]);
  }), _vm.filteredData.length === 0 ? _c('tr', [_c('td', {
    staticClass: "px-6 py-1 text-center text-sm text-gray-500",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No data available.")])]) : _vm._e()], 2)])]), _vm.baseData.is_valid ? _c('div', {
    staticClass: "flex flex-col justify-start items-start"
  }, [_c('div', {
    staticClass: "space-x-3"
  }, [_c('Button', {
    staticClass: "mt-4 text-gray-700",
    attrs: {
      "size": "xs"
    },
    on: {
      "click": _vm.saveItem
    }
  }, [_vm._v(" Save ")]), _c('Button', {
    staticClass: "mt-4 text-gray-700",
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "xs"
    },
    on: {
      "click": _vm.backToUpload
    }
  }, [_vm._v(" Cancel ")])], 1)]) : _c('div', [_c('Button', {
    staticClass: "mt-4 text-gray-700",
    attrs: {
      "variant": "outlined",
      "color": "alternative",
      "size": "xs"
    },
    on: {
      "click": _vm.backToUpload
    }
  }, [_vm._v(" Back to Choose Again ")])], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }